"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var AIRASIA_PREMIUM = {
  colors: {
    default: '#212124',
    primary: '#067E41',
    primaryDark: '#C92D21',
    primaryLight: '#FBEBE9',
    secondary: '#DC3224',
    secondaryDark: '#4448A0',
    secondaryLight: '#EDEDF6',
    tertiary: '#067E41',
    tertiaryDark: '#036835',
    tertiaryLight: '#E6F2EC',
    orange: '#C94318',
    orangeDark: '#B73810',
    orangeLight: '#FAECE8',
    blue: '#2F73D2',
    blueDark: '#2765BD',
    blueLight: '#EAF1FB',
    yellow: '#D97F00',
    neutral: '#FFFFFF',
    greyDarker: '#4C4C50',
    greyDark: '#75767A',
    greyMedium: '#C5C9D0',
    greyLight: '#D9DBE0',
    greyLighter: '#F8F8F8',
    gray: '#e5e5e5',
    black: '#000000'
  },
  backgroundColor: {
    default: '#212124',
    primary: '#212124',
    secondary: '#FFFFFF',
    tertiary: '#C5C9D0',
    black: '#000000'
  },
  fontFamily: {
    secondary: 'Libre Baskerville'
  }
};
var _default = AIRASIA_PREMIUM;
exports.default = _default;